import React, { useState } from 'react'
import { Formik, Form } from 'formik'
import { Roles } from 'utils/enums'
import RoleSelectorButton from 'components/common/Selectors';
import { Button } from '@mui/material';
import InputField from '../../common/Formik/InputField'

const rolesToShow = [Roles.Translator, Roles.Client, Roles.Account]
function LoginForm({
  initialValues,
  validationSchema,
  onSubmitForm,
  error,
  errorMessage,
  isSubmitting,
}) {
  const [role, setRole] = useState(rolesToShow[0]);

  return (
    <div className='flex flex-row w-full h-[100vh] pt-12'>
      <div className='py-12 flex-1'>
        <div className='flex bg-gray-100 rounded-lg shadow-2xl overflow-hidden
         mx-auto max-w-xs md:max-w-lg lg:max-w-xl'
        >
          <div className='w-full p-8 bg-purple-50'>
            <h1 className='mb-8 text-2xl font-semibold text-gray-600 text-center'>Login</h1>
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={(values) => onSubmitForm(values, role)}
              validateOnChange={false}
            >
              <Form>
                <div aria-hidden='true' className='hidden' id='app-version'>
                  v1.0.9
                </div>
                <div className='flex flex-col justify-center'>
                  <InputField label='Email' name='email' type='email' autoComplete />
                  <InputField label='Contraseña' name='password' type='password' autoComplete />
                  <RoleSelectorButton options={rolesToShow} onChange={setRole} />

                  <div className='m-2'>
                    <Button
                      className='text-white font-bold py-2 px-4 w-full rounded-lg'
                      type='submit'
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? 'Cargando...' : 'Ingresar'}
                    </Button>
                  </div>
                  {!error ? null : (
                    <span className='text-red-500 text-sm'>
                      {
                      error === 401
                        ? 'El usuario o la contraseña son invalidos, asegúrese de haber elegido el rol correcto'
                        : `Hay un problema con los datos ingresados: ${errorMessage}`
                    }
                    </span>
                  )}
                </div>
              </Form>
            </Formik>
          </div>
        </div>
      </div>
    </div>
  )
}

export default LoginForm
